import React, {forwardRef, useEffect, useMemo, useState} from 'react';
import {DashboardUser} from '@/types/dashboardUser';
import {Merchant} from '@/types/merchant';
import {Subscription} from '@/types/subscription';
import EmberIframe from '@/components/ember-iframe';
import useIsMobile from '@/hooks/use-is-mobile';
import {
  DashboardUserCurrentBrand,
  MENU_ITEMS__BASIC,
  MENU_ITEMS__FIFA_REVAMP,
} from './menuItems';
import SideNav from './side-nav';

export type MenuProps = {
  testID?: string;
  user: DashboardUser;
  currentBrand?: Merchant;
  subscription: Subscription;
  flags?: Record<string, boolean>;
  isCollapsed: boolean;
  handleCollapse: () => void;
};

function Menu(props: MenuProps, ref: React.ForwardedRef<HTMLDivElement>) {
  const {
    testID = 'menu',
    user: userData,
    currentBrand,
    subscription,
    flags = {},
    isCollapsed,
    handleCollapse,
  } = props;

  const isMobile = useIsMobile();
  const [userOverrideProps, setUserOverrideProps] =
    useState<Partial<DashboardUserCurrentBrand>>();

  useEffect(() => {
    return EmberIframe.listen(
      'dashboardUserUpdated',
      (dashboardUserProps: DashboardUserCurrentBrand) => {
        setUserOverrideProps(dashboardUserProps);
      }
    );
  }, []);

  const user = useMemo(
    () => ({...(userData || {}), ...userOverrideProps}),
    [userData, userOverrideProps]
  );

  const showCollapsed = isCollapsed && !isMobile;

  // Select menu items based on feature flags
  const menuItems = flags.fifaRevamp
    ? MENU_ITEMS__FIFA_REVAMP
    : MENU_ITEMS__BASIC;

  return (
    <SideNav
      ref={ref}
      testID={testID}
      menuItems={menuItems}
      user={user}
      currentBrand={currentBrand}
      subscription={subscription}
      flags={flags}
      isCollapsed={showCollapsed || false}
      handleCollapse={handleCollapse}
      isMobile={isMobile}
    />
  );
}

const MenuWithRef = forwardRef(Menu);

export default MenuWithRef;
